import React, { useEffect, useRef } from "react";
import insertScript from "helpers/insert-script";

const GorgiasWidget = ({ data }) => {
  const { show } = data;
  const scriptContainerRef = useRef(null);

  useEffect(() => {
    if (show && scriptContainerRef.current) {
      const existingScript = document.getElementById("gorgias-widget-script");
      if (!existingScript) {
        insertScript(
          scriptContainerRef.current,
          "https://config.gorgias.chat/bundle-loader/01JCP8PKPPRRQQ1RWCGTWH4E3V",
          "gorgias-widget-script",
          false,
          false,
          { "id": "gorgias-chat-widget-install-v3" }
        );
      }
    }

    return () => {
      const scriptElement = document.getElementById("gorgias-widget-script");
      if (scriptElement) {
        scriptElement.parentNode.removeChild(scriptElement);
      }
    };
  }, [show]);

  return (
    show && <div ref={scriptContainerRef} id="gorgias-widget-root"></div>
  );
};

export default GorgiasWidget;
